export default __webpack_public_path__ + "static/media/qrmaster-screenshot-05.b4eda11f.png";